module.exports = __webpack_public_path__ + "static/scale-model-of-detroit-observatory-in-ann-arbor-in-ann-arbor-michigan-73e163b6a17525702c9a9a473b228a8c.png";